import { $Diff } from 'utility-types'

import React, { Component, ComponentType, ElementConfig } from 'react'

import Scroller from 'client/shared/blocks/scroller'

export type FixedProps = {
  isFixed: () => boolean
  renderScroller: () => Node
}

type State = {
  fixed: boolean
}

function withFixed<Com extends ComponentType<any>>(
  DecoratedComponent: Com,
): ComponentType<$Diff<ElementConfig<Com>, FixedProps>> {
  class WithFixedDecorator extends Component<ElementConfig<Com>, State> {
    state = {
      fixed: false,
    }

    makeFixed = () => {
      this.setState({ fixed: true })
    }

    makeStatic = () => {
      this.setState({ fixed: false })
    }

    isFixed = () => this.state.fixed

    render() {
      return (
        <DecoratedComponent
          {...this.props}
          isFixed={this.isFixed}
          renderScroller={() => (
            <Scroller
              onReach={{ top: this.makeFixed, bottom: this.makeStatic }}
            />
          )}
        />
      )
    }
  }

  return WithFixedDecorator
}

export default withFixed
